import { render, staticRenderFns } from "./Mistakes.vue?vue&type=template&id=68434bfa&scoped=true"
import script from "./Mistakes.vue?vue&type=script&lang=js"
export * from "./Mistakes.vue?vue&type=script&lang=js"
import style0 from "./Mistakes.vue?vue&type=style&index=0&id=68434bfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68434bfa",
  null
  
)

export default component.exports